import { CustomComponentProps } from "utils/types/general.types";
import "assets/css/spinner.css";
export type LoadingProps = CustomComponentProps & {
    loading: boolean;
    children: React.ReactNode;
};
const Loading = ({ loading, children, className, style }: LoadingProps) => {
    return (
        <>
            {loading ? (
                <div
                    className={`w-full h-full flex justify-center items-center ${className}`}
                    style={{ ...style, minHeight: "200px" }}
                >
                    <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : (
                <>{children}</>
            )}
        </>
    );
};

export default Loading;
